import { render, staticRenderFns } from "./VisitMedical.vue?vue&type=template&id=1125655d&"
import script from "./VisitMedical.vue?vue&type=script&lang=js&"
export * from "./VisitMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports